<template>
    <div class="r-auth-register-company container">
        <h2>Create account</h2>
        <div class="row justify-content-center">
            <form
                class="col-lg-12"
                @submit.prevent="handleSubmit"
            >
                <h4 class="mt-4 mb-4">Select users.</h4>
                <companies-list-table
                    :selectedCompaniesId="selectedCompaniesId"
                    :companies="companies"
                    @onSelectedCompaniesIdChange="handleOnSelectedCompaniesIdChange"
                />
                <div class="row mt-4">
                    <div class="col-6 text-left">
                        <base-button
                            radius="bl"
                            component-class="blue"
                            @click.native="$router.push({ name: 'auth-register' })"
                        ><i class="fas fa-arrow-left mr-3"></i> Previous
                        </base-button>
                    </div>
                    <div class="col-6 text-right">
                        <base-button
                            radius="br"
                            component-class="green filled"
                            type="submit"
                        > Register <i class="fas fa-arrow-right ml-3"></i>
                        </base-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import BaseButton from '@/components/inputs/button/BaseButton';
    import CompaniesListTable from '@/components/Table/CompaniesListTable/CompaniesListTable';

    export default {
        computed: {
            ...mapState({
                companies: state => state.userCompanies.data,
                authData: state => state.auth ? state.auth.data : {},
                selectedCompaniesId: state => state.auth ? state.auth.selectedCompaniesId : [],
            }),
        },

        methods: {
            handleOnSelectedCompaniesIdChange(value) {
                this.$store.commit('auth/setStoreValue', { key: 'selectedCompaniesId', value});
            },
            async handleSubmit() {
                const { role, name, email, password } = this.authData;

                const credentials = {
                    role_id: role.value,
                    name,
                    email,
                    password,
                    selected_companies_id: this.selectedCompaniesId,
                };

                const isRegistered = await this.$store.dispatch('auth/register', credentials);
                if (isRegistered) {
                    this.$router.push({ name: 'auth-login'});
                }
            },
        },

        async mounted() {
            await this.$store.dispatch('userCompanies/getCompanies');
        },

        components: {
            'base-button': BaseButton,
            'companies-list-table': CompaniesListTable,
        }
    };
</script>
